import Skeleton from 'react-loading-skeleton';
import ListLoader from '~/components/ListLoader';
import { useBreakpoint } from '~/hooks';

export default function PackagesLoading() {
  const { mobileScreen, mdScreen } = useBreakpoint();
  const count = mobileScreen ? 2 : mdScreen ? 3 : 4;

  return (
    <div className="layout-boundary h-full">
      <div className="layout-boundary__inner flex flex-col gap-3x md:grid md:gap-4x md:grid-cols-3 lg:grid-cols-4 h-full px-2x md:px-0">
        {Array(count)
          .fill(0)
          .map((_, i) => {
            return (
              <div className="flex flex-col " key={`plan-loading-${i}`}>
                <div className="flex p-2x bg-gray_light_1 rounded-t-[12px] card-header element-center">
                  <Skeleton height={15} baseColor="white" />
                </div>
                <div className="flex flex-col  h-full justify-center gap-2x border border-gray border-t-0 rounded-b-[12px] px-2x pt-2x pb-3x">
                  <ListLoader height={15} count={6} />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
